'use client'

import DynamicPhotoSwipe from '@/components/extension/dynamic-photoswipe'
import { Button } from '@/components/ui/button'
import { ImageHelper } from '@/lib/helpers/image.helper'
import { cn } from '@/lib/utils'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import { useState } from 'react'

interface ImageProps {
  src: string
  width: number
  height: number
}

interface Props {
  images: ImageProps[]
  downloadUrl: string
}

export default function ConductPageContent({ images, downloadUrl }: Props) {
  const [isExpanded, setIsExpanded] = useState(false)
  const t = useTranslations('quy_tac_ung_xu_cua_coolmate_hardcode')

  return (
    <div className='mx-auto max-w-screen-xl px-4 md:px-0'>
      <h1 className='mb-8 text-center text-2xl font-bold md:text-3xl'>
        {t('title')}
      </h1>

      <div className='relative flex flex-col items-center justify-center'>
        <div
          className={cn(
            'pswp-gallery w-full max-w-5xl overflow-hidden transition-all duration-500',
            !isExpanded ? 'max-h-[80vh]' : 'max-h-auto'
          )}
          id='conduct-gallery'
        >
          {images.map((img, index) => (
            <a
              href={ImageHelper.getN7ImageUrl(img.src)}
              data-pswp-width={img.width}
              data-pswp-height={img.height}
              key={index}
              className='mb-4 block w-full cursor-zoom-in last:mb-0'
              target='_blank'
              rel='noopener noreferrer'
            >
              <Image
                src={ImageHelper.getN7ImageUrl(img.src)}
                width={img.width}
                height={img.height}
                alt={`Conduct - ${index + 1}`}
                className='h-auto w-full object-cover'
                unoptimized
                priority={index < 2}
              />
            </a>
          ))}
        </div>

        {!isExpanded && (
          <div className='pointer-events-none absolute bottom-0 left-0 h-[100px] w-full bg-gradient-to-t from-white to-transparent' />
        )}
      </div>

      <div className='sticky bottom-8 mt-8 flex flex-col items-center justify-center gap-2'>
        <Button
          onClick={() => setIsExpanded(!isExpanded)}
          variant='link'
          className='py-0 !text-black'
        >
          {isExpanded ? t('see_less') : t('see_more')}
        </Button>

        <a
          href={downloadUrl}
          download
          target='_blank'
          rel='noopener noreferrer'
          className='rounded-full bg-black px-8 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-neutral-800'
        >
          {t('download_document')}
        </a>
      </div>

      <DynamicPhotoSwipe id='conduct-gallery' />
    </div>
  )
}
